import {
  Button,
  Checkbox,
  Divider,
  Header,
  Icon,
  Modal,
  Segment,
  Tab,
  Table,
} from 'semantic-ui-react';
import { observer } from 'mobx-react-lite';
import { useStore } from '../../../../app/stores/store';
import { useEffect, useState } from 'react';
import ScheduleDatePicker from './ScheduleDatePicker';
import {
  rescheduleTasksPayloadType,
  scheduleTabDataType,
  scheduleTabSubTasks,
} from '../../../../app/api/types';
import agent from '../../../../app/api/agent';

type reviewChangesType = {
  subTaskId: string;
  subTaskName: string;
  fromDate: string;
  toDate: string;
};

export default observer(function ScheduleMetaData() {
  const {
    activityStore,
    PivotStore,
    OrderStore,
    commonStore,
    viewStore: { activeOrder },
  } = useStore();
  const [reviewChanges, setReviewChanges] = useState<reviewChangesType[]>([]);
  const [editEnabled, setEditEnabled] = useState(false);
  const [isExtend, setIsExtend] = useState(false);
  const [showModal, setShowModal] = useState(false);

  useEffect(() => {
    (async () => {
      if (activeOrder.templateId !== '') {
        OrderStore.getScheduleData();
      }
    })();
    // eslint-disable-next-line
  }, [activityStore.updateSchedule, activeOrder.templateId]);

  const onScheduleClick = () => {
    setEditEnabled(true);
    activityStore.scheduleEditOpen = true;
  };

  const getInfoFromSubTaskId = (
    taskId: string,
    subTaskId: string,
    fieldName: string,
  ) => {
    let value: any = '';
    OrderStore?.scheduleData?.forEach((w: scheduleTabDataType) => {
      if (w.taskId === taskId) {
        w.subtasks?.forEach((s: scheduleTabSubTasks) => {
          if (s.subTaskId === subTaskId) {
            value = s?.[fieldName as keyof scheduleTabSubTasks];
            return value;
          }
        });
      }
    });
    return value;
  };

  const cancelClick = async () => {
    setReviewChanges([]);
    const workFlowMetaData = await agent.workflowStatus.scheduleTabData(
      activeOrder.templateId,
    );
    workFlowMetaData.data?.sort((a: any, b: any) => {
      return a.taskIndex - b.taskIndex;
    });
    // setWorkFlow(workFlowMetaData.data);
    setEditEnabled(false);
    activityStore.scheduleEditOpen = false;
  };

  const getChangedDate = (
    taskId: string,
    subTaskId: string,
    newDate: string,
  ) => {
    let updated = false;
    reviewChanges?.forEach((r: reviewChangesType, index) => {
      if (r.subTaskId === subTaskId) {
        const reviewChangeObject: reviewChangesType = {
          subTaskId,
          subTaskName: r.subTaskName,
          fromDate: r.fromDate,
          toDate: newDate,
        };
        const copyOfReviewChanges = [...reviewChanges];
        copyOfReviewChanges[index] = reviewChangeObject;
        setReviewChanges(copyOfReviewChanges);
        updated = true;
      }
    });
    if (!updated) {
      const reviewChangeObject: reviewChangesType = {
        subTaskId,
        subTaskName: getInfoFromSubTaskId(taskId, subTaskId, 'subTaskName'),
        fromDate: PivotStore.dateFormat(
          getInfoFromSubTaskId(taskId, subTaskId, 'endSTDate'),
        ),
        toDate: newDate,
      };
      setReviewChanges((reviewChanges) => [
        ...reviewChanges,
        reviewChangeObject,
      ]);
    }
    updated = false;
  };

  const handleReschedule = async () => {
    const itemId = activityStore.selectedActivity?.id;
    const templateId = activeOrder.templateId;
    const payload: rescheduleTasksPayloadType[] = [];
    reviewChanges?.forEach((r: reviewChangesType) => {
      payload.push({
        subtaskId: r.subTaskId,
        toDate: r.toDate,
      });
    });
    await OrderStore.rescheduleSubTasks(itemId, templateId, isExtend, payload);
    setReviewChanges([]);
    setIsExtend(false);
    setEditEnabled(false);
  };

  return (
    <>
      <Tab.Pane
        className={
          commonStore.filterModeZero?.includes('AVLAVF04')
            ? 'metadata-parent-tab schedule-tab component-isDisabled'
            : 'metadata-parent-tab schedule-tab'
        }
      >
        <div>
          {OrderStore?.scheduleData?.length === 0 ? (
            <Header
              style={{
                margin: '0px',
                padding: '20px',
                textAlign: 'center',
              }}
            >
              No active workflow
            </Header>
          ) : (
            <>
              <div
                style={{
                  display: 'flex',
                  justifyContent: 'space-between',
                }}
              >
                {commonStore.filterModeTwo?.includes('AVLAVF06') ? (
                  <></>
                ) : (
                  <div
                    style={{
                      display: 'flex',
                      alignItems: 'center',
                    }}
                    className={
                      commonStore.filterModeZero?.includes('AVLAVF06')
                        ? 'component-isDisabled'
                        : ''
                    }
                  >
                    <Checkbox
                      id="extend-date"
                      onClick={() => setShowModal(true)}
                      checked={isExtend}
                    />
                    <label style={{ marginLeft: '5px' }} htmlFor="extend-date">
                      Extend Project End Date
                    </label>
                  </div>
                )}
                <>
                  {commonStore.filterModeTwo?.includes('AVLAVF05') ? (
                    <></>
                  ) : (
                    <>
                      {!editEnabled ? (
                        <Button
                          color="teal"
                          onClick={onScheduleClick}
                          disabled={commonStore.filterModeZero?.includes(
                            'AVLAVF05',
                          )}
                        >
                          Reschedule
                        </Button>
                      ) : (
                        <div className="schedule-btns">
                          <Button
                            color="blue"
                            disabled={reviewChanges.length === 0}
                            onClick={handleReschedule}
                          >
                            Save
                          </Button>
                          <Button color="orange" onClick={cancelClick}>
                            Cancel
                          </Button>
                        </div>
                      )}
                    </>
                  )}
                </>
              </div>
              {reviewChanges.length > 0 ? (
                <Segment.Group className="MetaDataUser">
                  <Divider horizontal>
                    <Header color="teal" as="h5">
                      Review Changes
                    </Header>
                  </Divider>
                  <div
                    style={{
                      height: '100%',
                      maxHeight: '500px',
                      overflowY: 'scroll',
                    }}
                  >
                    <Table definition>
                      <Table.Body>
                        {reviewChanges.map((data: reviewChangesType) => {
                          return (
                            <Table.Row key={data.subTaskName}>
                              <Table.Cell width={6}>
                                {data.subTaskName}
                              </Table.Cell>
                              <Table.Cell width={6}>
                                {data.fromDate} --&gt; {data.toDate}
                              </Table.Cell>
                            </Table.Row>
                          );
                        })}
                      </Table.Body>
                    </Table>
                  </div>
                </Segment.Group>
              ) : null}
              {OrderStore?.scheduleData &&
                OrderStore?.scheduleData?.map((w: scheduleTabDataType) => {
                  return (
                    <>
                      {w.taskName !== '' && (
                        <Segment.Group className="MetaDataUser">
                          <Divider horizontal>
                            <Header color="teal" as="h5">
                              {w.taskName}
                            </Header>
                          </Divider>
                          <div
                            style={{
                              height: '100%',
                              maxHeight: '500px',
                              overflowY: 'scroll',
                            }}
                          >
                            <Table definition>
                              <Table.Header></Table.Header>
                              <Table.Body>
                                {w.subtasks.map((data: scheduleTabSubTasks) => {
                                  return (
                                    <>
                                      {data.subTaskName !== '' && (
                                        <Table.Row>
                                          <Table.Cell
                                            width={
                                              window.innerWidth < 767 ? 7 : 6
                                            }
                                          >
                                            {data.subTaskName}
                                          </Table.Cell>
                                          <Table.Cell
                                            width={
                                              window.innerWidth < 767 ? 7 : 6
                                            }
                                            style={{
                                              padding: '0 0 5px 10px',
                                            }}
                                          >
                                            <div
                                              style={{
                                                display: 'flex',
                                                alignItems: 'center',
                                              }}
                                            >
                                              {data.status === 2 ? (
                                                <Icon.Group
                                                  style={{
                                                    marginTop: '8px',
                                                  }}
                                                >
                                                  <Icon
                                                    name="calendar outline"
                                                    color="blue"
                                                  />
                                                  <Icon
                                                    corner
                                                    name="close"
                                                    color="red"
                                                  />
                                                </Icon.Group>
                                              ) : (
                                                <Icon
                                                  name="calendar outline"
                                                  color="blue"
                                                  style={{
                                                    width: 'auto',
                                                    height: 'auto',
                                                  }}
                                                />
                                              )}
                                              <ScheduleDatePicker
                                                taskId={w.taskId}
                                                subTaskDetails={data}
                                                getChangedDate={getChangedDate}
                                                editEnabled={editEnabled}
                                                isExtend={isExtend}
                                              />
                                              {data.status === 2 ? (
                                                <Icon
                                                  name="check circle"
                                                  size="large"
                                                  style={{
                                                    marginTop: '3px',
                                                  }}
                                                  color="green"
                                                />
                                              ) : null}
                                            </div>
                                          </Table.Cell>
                                        </Table.Row>
                                      )}
                                    </>
                                  );
                                })}
                              </Table.Body>
                            </Table>
                          </div>
                        </Segment.Group>
                      )}
                    </>
                  );
                })}
            </>
          )}
        </div>
      </Tab.Pane>
      {showModal ? (
        <Modal open={true} onClose={() => setShowModal(false)}>
          <Modal.Header>Confirmation</Modal.Header>
          <Modal.Content>
            <Modal.Description>
              {isExtend
                ? 'Are you sure to shrink the schedule changes within Project End Date ?'
                : 'Are you sure to extend the Project End Date ?'}
            </Modal.Description>
          </Modal.Content>
          <Modal.Actions>
            <Button color="black" onClick={() => setShowModal(false)}>
              Cancel
            </Button>
            <Button
              content={isExtend ? 'Save' : 'Extend'}
              labelPosition="right"
              icon="checkmark"
              onClick={() => {
                setShowModal(false);
                setIsExtend(!isExtend);
              }}
              positive
            />
          </Modal.Actions>
        </Modal>
      ) : null}
    </>
  );
});
